<div>
  <span>Tempo médio: </span>
  <span class="card-padrao-list-box-bg-value" style="padding: 2px 6px;display: inline-block;">{{ tempoMedio }}</span>
</div>
